import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { Eye, Trash2 } from "lucide-react";
import { stageConfig } from "./constants";

const calcOppMRR = (opp) => {
  if (!opp.selected_services?.length) return opp.estimated_mrr || 0;
  return opp.selected_services.reduce((total, svc) => {
    const qty = parseInt(svc.cantidad) || 1;
    return total + (svc.precio * qty) - (svc.descuento || 0);
  }, 0);
};

export const PipelineTable = ({
  filteredOpportunities,
  formatCurrency,
  openDetail,
  canDelete,
  openDeleteConfirm,
}) => (
  <Card className="bg-[#0F0F3D] border-[#1E1E5F]">
    <CardContent className="p-0">
      <Table>
        <TableHeader>
          <TableRow className="border-[#1E1E5F] hover:bg-transparent">
            <TableHead className="text-[#03BEE4]">ID</TableHead>
            <TableHead className="text-[#03BEE4]">Título</TableHead>
            <TableHead className="text-[#03BEE4]">Cliente</TableHead>
            <TableHead className="text-[#03BEE4]">Servicios</TableHead>
            <TableHead className="text-[#03BEE4]">Ejecutivo</TableHead>
            <TableHead className="text-[#03BEE4]">Etapa</TableHead>
            <TableHead className="text-[#03BEE4]">MRR Est.</TableHead>
            <TableHead className="text-[#03BEE4]">Acciones</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filteredOpportunities.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center text-slate-400 py-8">
                No hay oportunidades que mostrar
              </TableCell>
            </TableRow>
          ) : (
            filteredOpportunities.map((opp) => (
              <TableRow
                key={opp.id}
                className="border-[#1E1E5F] hover:bg-[#1B1B4B] cursor-pointer"
                onClick={() => openDetail(opp)}
              >
                <TableCell className="text-[#42E695] font-mono">{opp.opportunity_id}</TableCell>
                <TableCell className="text-white font-medium">{opp.title}</TableCell>
                <TableCell className="text-slate-300">{opp.customer_name}</TableCell>
                <TableCell className="text-slate-300">
                  {opp.selected_services?.length || 0} servicio(s)
                </TableCell>
                <TableCell className="text-slate-300">{opp.ejecutivo_nombre || "-"}</TableCell>
                <TableCell>
                  <Badge className={`${stageConfig[opp.stage]?.color} text-white`}>
                    {stageConfig[opp.stage]?.label || opp.stage}
                  </Badge>
                </TableCell>
                <TableCell className="text-white">{formatCurrency(calcOppMRR(opp))}</TableCell>
                <TableCell>
                  <div className="flex items-center gap-1">
                    <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); openDetail(opp); }}>
                      <Eye className="h-4 w-4 text-[#03BEE4]" />
                    </Button>
                    {canDelete && (
                      <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); openDeleteConfirm(opp.id); }} data-testid={`delete-opp-${opp.id}`}>
                        <Trash2 className="h-4 w-4 text-red-400" />
                      </Button>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);
